import { useLocalTranslation } from '@/hooks/useLocalTranslation';
import SeriesCard from '@/components/dashboard/seriesCard'
import { seriesStatus } from '@/pages/dashboard/constants'

import "./style.css"
import { themes } from '@/constants/colors_v2';
import { useSelector } from 'react-redux';
import { RootState } from '@/store';

export default function WatchView(props: any) {
    const { timeline, common } = useLocalTranslation();
    const currentTheme = useSelector((state: RootState) => state.currentThemeReducer.currentTheme);

    return (
        <div className='mb-[11px] WatchViewMain timelineSectionsCommonPaddingLeft'>
            {/* <p
                style={{
                    marginTop: "-2px"
                }}
                className='text-red-500 text-[12px] font-medium mb-[1px]'>{props.apiErrMsg}</p> */}

            {props.timelineDetails.courseStartAt ? (
                <>
                    {props.timelineDetails.series.map((serie: any, index: number) => (
                        <div key={index}
                            className={`solo ${index + 1 !== props.timelineDetails.series.length ? 'mb-[18px]' : 'mb-[0px]'}`}>
                            <SeriesCard
                                key={index}
                                serie={serie}
                                anyOneInstallmentOverDue={props.timelineDetails.installmentOverdue}
                                source={"timeline"}
                                hideThumbnail={true}
                            />
                        </div>
                    ))}

                    {/* {serie.seriesStatus === seriesStatus.expired && */}                
                    {props.areAllSeriesExpired() && props.timelineDetails.extendedDurationPresetId 
                        && props.timelineDetails.extendedDurationPresetDetails
                        && Object.entries(props.timelineDetails.extendedDurationPresetDetails).length > 0  &&
                        <div className='extenDurationConBelowSeriesCard'>
                            {common.statusText.extendDuration1}{" "}
                            <button
                                onClick={props.handleExtendDuration}
                                className='text-[#0173e7]'>
                                {common.statusText.extendDuration}
                            </button>
                        </div>
                    }
                </>
            ) : (
                <div className='flex gap-[10px]'>
                    <button
                        style={{
                            cursor: (props.isSectionLocked || props.startCourseBtnLoading) ? 'not-allowed' : 'pointer',
                            // backgroundColor: (props.isSectionLocked || props.startCourseBtnLoading) ? '#b9b9ba' : '#0073E6'
                            backgroundColor: (props.isSectionLocked || props.startCourseBtnLoading) ? 
                            (currentTheme === themes.dark ? 'var(--gray-color8)' : 'var(--gray-color40)')
                            : 
                            'var(--blue-color2)',

                            color: (props.isSectionLocked || props.startCourseBtnLoading) ? 
                            (currentTheme === themes.dark ? 'var(--gray-color29)' : 'var(--white-color)')
                            : 
                            'var(--white-color)'
                        }}
                        disabled={(props.isSectionLocked || props.startCourseBtnLoading)}
                        onClick={() => { props.openPop('startCourse') }}
                        className={` ${props.isSeriesWatchLaterAtAvaliable() ? 'w-[100%]' : 'w-1/2'}  cursor-pointer py-[7px] rounded-[5px] text-[14px]`}>
                        {timeline.watchSection.startCourse}
                    </button>

                    {/* {!props.timelineDetails.seriesWatchLaterAt && */}
                    {!props.isSeriesWatchLaterAtAvaliable() &&
                        <button
                            style={{
                                cursor: (props.isSectionLocked || props.iWillStartLaterBtnLoading) ? 'not-allowed' : 'pointer',

                                // backgroundColor: (props.isSectionLocked || props.iWillStartLaterBtnLoading) ? '#b9b9ba' : (currentTheme === themes.dark) ? 'var(--gray-color30)' : 'var(--white-color4)'


                                backgroundColor: (props.isSectionLocked || props.startCourseBtnLoading) ? 
                                (currentTheme === themes.dark ? 'var(--gray-color8)' : 'var(--gray-color40)')
                                : 
                                (currentTheme === themes.dark) ? 'var(--gray-color30)' : 'var(--white-color4)',    

                                color: (props.isSectionLocked || props.startCourseBtnLoading) ? 
                                (currentTheme === themes.dark ? 'var(--gray-color29)' : 'var(--white-color)')
                                : 
                                (currentTheme === themes.dark) ? 'var(--white-color)' : 'var(--black-color)'
    


                            }}
                            disabled={(props.isSectionLocked || props.iWillStartLaterBtnLoading)}
                            onClick={() => { props.openPop('startCourseLater') }}
                            className='w-1/2 cursor-pointer py-[7px] rounded-[5px] text-[14px]'>
                            {timeline.watchSection.iWillStartLater}
                        </button>
                    }
                </div>
            )}
        </div>
    );
};

